export default __webpack_public_path__ + "static/media/revenue_disabled.66ac488d.svg";